<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>

<div dir="{{languageDir}}">
    <div class="content-top-box">
        <app-bread-crumb></app-bread-crumb>
    </div>

    <div class="content">
        <div class="header-title">
            <h1 class="main-title">{{t('WorkOrder', 'Work Order')}}</h1> &nbsp;
            <button mat-icon-button *ngIf="isWrite | permissionChecker" class="add-button" (click)="addOperator()">
                <mat-icon class="menu">add</mat-icon>
            </button>
        </div>
        <form name="HeaderForm" [formGroup]="HeaderForm" class="w-70">
            <div class="w-100 headerForm d-flex">
                <div class="inputField w-20">
                    <nz-date-picker class="date-picker" readonly [nzShowTime]="false" nzFormat="dd-MMM-yyyy"
                        [(ngModel)]="dateFilter.From" formControlName="fromDate" (ngModelChange)="getFilterData()">
                    </nz-date-picker>
                    <span class="floating-text">{{t('From', 'From')}}</span>
                    <div *ngIf="!dateFilter.From" class="error-message">{{t('Fromdateisrequired', 'From date is required')}}</div>
                </div>

                <div class="inputField w-20">
                    <nz-date-picker class="date-picker" readonly [nzShowTime]="false" nzFormat="dd-MMM-yyyy"
                        [(ngModel)]="dateFilter.To" formControlName="toDate" (ngModelChange)="getFilterData()">
                    </nz-date-picker>
                    <span class="floating-text">{{t('To', 'To')}}</span>
                    <div *ngIf="!dateFilter.To" class="error-message">{{t('Todateisrequired', 'To date is required')}}</div>
                    <div *ngIf="dateFilter.From > dateFilter.To && dateFilter.To" class="error-message">{{t('TodatemustbegreaterthanFromdate', 'To date must be greater than From date')}}
                    </div>
                </div>

                <mat-form-field appearance="fill" class="w-20">
                    <mat-label>{{t('Search', 'Search')}}</mat-label>
                    <input matInput type="text" (keyup)="onFilterChanged($event.target)">
                </mat-form-field>
            </div>
        </form>

        <div class="import_export">
            <button *ngIf="isAccess | permissionChecker" class="export" (click)="ExportTOExcel()">
                {{t('Export', 'Export')}}</button>
        </div>
    </div>

    <div class="d-flex justify-content-center" style="margin-top: 50px;">
        <div class="score-cards-wrapper d-flex" style="gap: 12px;">
          <mat-card class="open" style="padding: 10px; text-align: center; background-color: #f8f9fa;">
            <b color="warn">{{t('OpenedTasks', 'Opened Tasks')}} : {{openCount}}</b>
          </mat-card>  
          <mat-card class="closed" style="padding: 10px; text-align: center; background-color: #e9ecef;">
            <b>{{t('ClosedTasks', 'Closed Tasks')}} : {{closedCount}}</b>
          </mat-card>  
          <mat-card class="completed" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
            <b>{{t('CompletedTasks', 'Completed Tasks')}} : {{completedCount}}</b>
          </mat-card>
          <mat-card class="inprogress" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
            <b>{{t('InprogressTasks', 'In-progress Tasks')}} : {{inProgressCount}}</b>
          </mat-card>     
          <!-- <mat-card class="delayed" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
            <b>{{t('DelayedTasks', 'Delayed Tasks')}} : {{delayedCount}}</b>
          </mat-card> -->
        </div>
      </div>

    <div style="margin-top: 20px;">
        <ag-grid-angular style="width: 100%; height: 30vw;" class="ag-theme-alpine" [rowData]="rowData"
            [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (cellClicked)="cellClicked($event)"
            [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10"
            [frameworkComponents]="frameworkComponents">
        </ag-grid-angular>
    </div>

    <ng-template #workPermitDialog>
        <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 20px;">
            <h1 style="margin: 0;">{{t('WorkPermitInfo', 'Work Permit Info')}}</h1>
            <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
                <i class="fa fa-times" style="color: #fff"></i>
            </button>
        </div>
        <div class="container">
            <form name="" [formGroup]="">
                <div class="row">
                    <mat-form-field appearence="fill" class="col">
                        <mat-label>{{t('Title', 'Title')}}</mat-label>
                        <input matInput type="text" formControlName="Title">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field appearence="fill" class="col">
                        <mat-label>{{t('Department', 'Department')}}</mat-label>
                        <mat-select required formControlName="Department">
                            <mat-option value=1> Department-1 </mat-option>
                            <mat-option value=2> Department-2 </mat-option>
                            <mat-option value=3> Department-3 </mat-option>
                            <mat-option value=4> Department-4 </mat-option>
                            <mat-option value=5> Department-5 </mat-option>
                        </mat-select>
                        <mat-error>{{t('DepartmentisRequired', 'Department is required')}}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearence="fill" class="col">
                        <mat-label>{{t('WorkCondition', 'Work Condition')}}</mat-label>
                        <mat-select required formControlName="WorkCondition">
                            <mat-option value=1> Work Condition-1 </mat-option>
                            <mat-option value=2> Work Condition-2 </mat-option>
                            <mat-option value=3> Work Condition-3 </mat-option>
                            <mat-option value=4> Work Condition-4 </mat-option>
                            <mat-option value=5> Work Condition-5 </mat-option>
                        </mat-select>
                        <mat-error>{{t('WorkConditionisRequired', 'Work condition is required')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field appearence="fill" class="col">
                        <mat-label>{{t('WorkPermitApprover', 'Work Permit Approver')}}</mat-label>
                        <mat-select required formControlName="WorkPermitApprover">
                            <mat-option value=1> WorkPermitApprover-1 </mat-option>
                            <mat-option value=2> WorkPermitApprover-2 </mat-option>
                            <mat-option value=3> WorkPermitApprover-3 </mat-option>
                            <mat-option value=4> WorkPermitApprover-4 </mat-option>
                            <mat-option value=5> WorkPermitApprover-5 </mat-option>
                        </mat-select>
                        <mat-error>{{t('WorkPermitApproverisRequired', 'Work permit approver is required')}}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearence="fill" class="col">
                        <mat-label>{{t('AdditionalWorkPermitApprover', 'Additional Work Permit Approver')}}</mat-label>
                        <mat-select required formControlName="WorkCondition">
                            <mat-option value=1> AdditionalWorkPermitApprover-1 </mat-option>
                            <mat-option value=2> AdditionalWorkPermitApprover-2 </mat-option>
                            <mat-option value=3> AdditionalWorkPermitApprover-3 </mat-option>
                            <mat-option value=4> AdditionalWorkPermitApprover-4 </mat-option>
                            <mat-option value=5> AdditionalWorkPermitApprover-5 </mat-option>
                        </mat-select>
                        <mat-error>{{t('AdditionalWorkPermitApproverisRequired', 'Additional work permit approver is required')}}</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div class="row">
                    <mat-form-field appearance="fill" class="col"> 
                        <mat-label>Start Date*</mat-label>
                        <input
                            required
                            formControlName="StartDate"
                            matInput
                            [ngxMatDatetimePicker]="startDatePicker"
                            placeholder="Choose a start date"
                            [disabled]="isView || disable"
                        />
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #startDatePicker></ngx-mat-datetime-picker>
                        <mat-error *ngIf="yourFormGroupName.get('StartDate').hasError('required')">Start Date is required</mat-error>
                    </mat-form-field>
    
                    <mat-form-field appearance="fill" class="col"> 
                        <mat-label>End Date*</mat-label>
                        <input
                            required
                            formControlName="EndDate"
                            matInput
                            [ngxMatDatetimePicker]="endDatePicker"
                            placeholder="Choose an end date"
                            [disabled]="isView || disable"
                        />
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #endDatePicker></ngx-mat-datetime-picker>
                        <mat-error *ngIf="yourFormGroupName.get('EndDate').hasError('required')">End Date is required</mat-error>
                    </mat-form-field>
                </div> -->
    
                <!-- <div class="row">
                    <mat-form-field appearance="fill" class="col"> 
                        <mat-label>Start Time</mat-label>
                        <input formControlName="StartTime" matInput placeholder="Start Time">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col"> 
                        <mat-label>End Time</mat-label>
                        <input formControlName="EndTime" matInput placeholder="End Time">
                    </mat-form-field>
                </div> -->
            </form>
        </div>
    </ng-template>

</div>